<template>
    <v-dialog v-model="showPopup" max-width="600px" persistent>
        <div class="popup">
            <div class="popup-header">
                <div class="pr-title">RENAME DOCUMENT</div>
                <button class="circle" @click="closePopup">
                    <img :src="require('@/assets/icons/close.svg')" alt="">
                </button>
            </div>
            <v-form v-model="isFormValid" class="popup-body" @submit.prevent="changeName">

                <div class="popup-input">
                    <div class="label">Document Name</div>
                    <v-text-field v-model="renamedDoc" :rules="[nameRules]" variant="outlined" density="compact"
                        bg-color="var(--bg-color)"></v-text-field>
                </div>
                <div class="popup-footer">
                    <button class="discard-btn" @click.prevent="closePopup">
                        <span>Discard</span>
                    </button>

                    <button class="save-changes-btn"
                        :disabled="saveLoader || !isFormValid || originalName === renamedDoc" @click="changeName">
                        <span>Save Changes</span>
                        <v-progress-circular v-if="saveLoader" indeterminate :size="18" class="gradient-spinner"
                            :width="2"></v-progress-circular>
                    </button>
                </div>
            </v-form>
            <ConfirmPopup v-if="confirmPopup" v-model="confirmPopup" :title="`${messageTitle} Renamed Successfully`"
                :image="successImage" :type="'success'" />
        </div>
    </v-dialog>

</template>

<script>
import axiosInstance from '@/axiosInterceptor';
import { Eventbus } from '@/plugins/eventBus';
import ConfirmPopup from './ConfirmPopup.vue';

export default {

    components: {
        ConfirmPopup
    },
    props: {
        isEditing: {
            type: Boolean,
            default: false,
        },
        docName: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: '',
        },
        flowType: {
            type: String,
            default: '',
        },
    },

    data() {

        return {
            showPopup: this.isEditing,
            successImage: require('@/assets/icons/success.svg'),
            confirmPopup: false,
            isFormValid: false,
            renamedDoc: null,
            saveLoader: false,
            originalName: null,
            messageTitle: null,
        }
    },

    mounted() {
        this.renamedDoc = this.docName;
        this.originalName = this.docName;
    },

    computed: {
        nameRules() {
            return (value) => {
                if (!value) return true;
                else if (value.length < 3) return "Document name must be at least 3 characters";
                else if (value.length > 100) return 'Document name must be less than 100 characters';
                else return true;
            }
        }
    },

    methods: {
        closePopup() {
            this.$emit('update-isEdit', false);
        },
        removeNumbers() {
            this.renamedDoc = this.renamedDoc.replace(/[0-9]/g, '');
        },

        async changeName() {
            this.saveLoader = true;
            let payload;
            let endpoint;
            if (this.flowType === 'pressRelease') {
                this.messageTitle = 'PR';
                payload = {
                    prName: this.renamedDoc || '',
                    prId: this.$route.params.prId || this.id,
                };
                endpoint = '/pr/title';
            } else if (this.flowType === 'narrative') {
                this.messageTitle = 'Narrative';
                payload = {
                    narrativeName: this.renamedDoc || '',
                    narrativeId: this.$route.params.narrativeId || this.id,
                };
                endpoint = "/narrative/title";
            }
            else if (this.flowType === 'messageHouse') {
                this.messageTitle = 'Message House';
                payload = {
                    messageHouseName: this.renamedDoc || '',
                    msgHouseId: this.$route.params.msgHouseId || this.id,
                };
                endpoint = "/messageHouse/title";
            }
            else if (this.flowType === 'prcampaign') {
                this.messageTitle = 'PR Strategy';
                payload = {
                    title: this.renamedDoc || '',
                    prCampaignId: this.$route.params.prCampaignId || this.id,
                };
                endpoint = "/prCampaign/title";
            }
            else if (this.flowType === 'article') {
                this.messageTitle = 'Article';
                payload = {
                    articleDocumentName: this.renamedDoc || '',
                    articleId: this.$route.params.articleId || this.id,
                };
                endpoint = "/article/title";
            }
            else if (this.flowType === 'socialStrategy') {
                this.messageTitle = 'Social Media Campaign';
                payload = {
                    docName: this.renamedDoc || '',
                    socialStrategyId: this.$route.params.socialStrategyId || this.id,
                };
                endpoint = "/socialMedia/title";
            }
            else if (this.flowType === 'storyBank') {
                this.messageTitle = 'Storybank';
                payload = {
                    title: this.renamedDoc || '',
                    storyBankId: this.$route.params.storyBankId || this.id,
                };
                endpoint = "/storyBank/title";
            }
            else if (this.flowType === 'crisis') {
                this.messageTitle = 'Crisis Document';
                payload = {
                    title: this.renamedDoc || '',
                    crisisDocumentId: this.$route.params.crisisDocumentId || this.id,
                };
                endpoint = "/crisis/title";
            }
            await axiosInstance.put(endpoint, payload)
                .then((response) => {
                    this.confirmPopup = true;
                    setTimeout(() => {
                        this.showPopup = false;
                        this.confirmPopup = false;
                        this.$emit('update-isEdit', this.showPopup);
                        this.$emit('updated-prTitle', this.renamedDoc);
                    }, 1000);

                })
                .catch((error) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: "error",
                        message: `Failed to update document title`
                    });
                })
                .finally(() => {
                    this.saveLoader = false;
                })
        }
    }
}
</script>

<style scoped>
.popup {
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E0E9ED;
    border-radius: 8px;
}

.popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    font-weight: 600;
    font-family: monospace;
    font-size: 20px;
}

.circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 8px;
    border: 2px solid #D4D4D4;
}

.popup-body {
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 16px;
    overflow: auto;
    height: 100%;
}

.popup-input {
    display: flex;
    flex-direction: column;
    gap: 12px;
    font-weight: 500;
}

.popup-footer {
    display: flex;
    justify-content: space-between;
    gap: 1em;
}

.save-changes-btn {
    width: 50%;
    padding: 12px;
    background: #171717;
    color: white;
    border: 1px solid #525252;
    border-radius: 12px;
    font-weight: 500;
}

.discard-btn {
    width: 50%;
    padding: 12px;
    background: white;
    border: 1px solid #525252;
    border-radius: 12px;
    font-weight: 500;
}

button:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}
</style>